import React, { ReactNode, useEffect } from "react";
import useAppSelector from "../../hooks/useAppSelector";
import { useNavigate } from "react-router-dom";
import { getAccessToken } from "../../helper/auth";
import { AuthService } from "../../services/auth.service";
import useAppDispatch from "../../hooks/useAppDispatch";
import { login, logout } from "../../store/userProfile/userProfileSlice";

interface IAuthProviderProps {
  children: ReactNode;
}

const AuthProvider: React.FC<IAuthProviderProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isAuthorized } = useAppSelector((state) => state.userProfileSlice);

  useEffect(() => {
    if (getAccessToken()) {
      AuthService.getCurrentUser().then((res) => {
        if (res?.data && res.status === 200) {
          dispatch(login(res.data));
        } else {
          dispatch(logout());
          AuthService.logout();
        }
      });
    } else {
      dispatch(logout());
      AuthService.logout();
    }
  }, [getAccessToken()]);

  useEffect(() => {
    if (isAuthorized === false) {
      navigate("/auth");
    }
  }, [isAuthorized, navigate]);

  return <>{isAuthorized && children}</>;
};

export default AuthProvider;
